import { Component, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { EspecificationService } from '../../services/especification.service';
import { Specification } from '../../model/Specification';
/*import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';*/
/*import { listLocales } from 'ngx-bootstrap/chronos';*/
/*import { CreateNewAutocompleteGroup, SelectedAutocompleteItem, NgAutocompleteComponent } from "ng-auto-complete";*/

@Component({
  selector: 'especificacion',
  templateUrl: './especificacion.component.html',
  styleUrls: ['./especificacion.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EspecificacionComponent implements OnInit {
  @ViewChild(ModalDirective) public lgModal: ModalDirective;
  //@ViewChild(NgAutocompleteComponent) public completer: NgAutocompleteComponent;
  public load:number;
  public primeracarga:boolean;
  public isopen:boolean;
  public alert:string;
  public data_list:any;
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public item_to_update:number;
  public settings = {
    columns:{
      number: { header: "Numero Especificación", type:"text" }
    },
    actions:{
      edit: true,
      view: false,
      delete: true
    }
  };

  constructor(private _especificationService:EspecificationService,private _loaddata: LoadService) {
    this.isopen = false;
    this.alert = "";
    this.primeracarga = false;
  }

  ngOnInit() {
    this._loaddata.loadChange(15);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'id': new FormControl("-1",Validators.required),
      'codigo': new FormControl(null,Validators.required),
      'clientes':new FormArray([])
    });
    this.loadData();
  }

  loadDataFiltered(filters){
    //console.log("Filtrando");
    this.isopen = false;
    this._loaddata.loadChange(90);
    this._especificationService.getDataFiltered(filters)
    .subscribe(
      (response:any) => {
        //console.log(response.data);
        this.cleanForm();
        this.data_list = response.data;
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert += "Carga Correcta."
        this.isopen =true;
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

/**
 * Carga el listado de informacion.
 */
  loadData():void{
    this.isopen = false;
    this._loaddata.loadChange(90);
    this._especificationService.get()
    .subscribe(
      (response:any) => {
        this.cleanForm();
        this.data_list = response.data;
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert += "Carga Correcta."
        this.isopen =true;
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

/**
 * Envia a la BD los datos del formulario.
 */
  saveForm():void{
    this.alert = "";
    this.isopen =false;
    this._loaddata.loadChange(40);
    let prov = this._especificationService.transformData(this.signupForm.value);
    this._especificationService.save(prov).subscribe(
      response =>{
        this._loaddata.loadChange(60);
        this.hideChildModal();
        this.loadData();
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

/**
 * Envia a la BD los datos a actualizar.
 */
  updateForm():void{
    this.alert = "";
    this.isopen =false;
    this._loaddata.loadChange(35);
    let htmlbody = this._especificationService.transformData(this.signupForm.value);
    let url = this.data_list[this.item_to_update]['links'].self;
    this._especificationService.update(url, htmlbody).subscribe(
      data => {
        this._loaddata.loadChange(70);
        this.alert = "Elemento actualizado.";
        this.hideChildModal();
        this.loadData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

/**
 * Elimina la fila seleccionada de la BD
 * @param  data id de la fila a eliminar
 */
  deleteItem(data):void{
    this.alert = "";
    this.isopen =false;
    this._loaddata.loadChange(35);
    this._especificationService.delete(data.url).subscribe(
      response => {
          this._loaddata.loadChange(70);
          this.alert = "Elemento eliminado.";
          this.loadData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

/**
 * Carga la información de una fila en el formulario.
 * @param  index Indice de la fila que se carga en el formulario.
 */
  showEditForm(index) {
    this.item_to_update = index;
    let item = this.data_list[index];

    let po = new Specification(
      item.id,
      item.attributes.number
    );
    //this.signupForm.setValue(po);
    this.signupForm.patchValue({
      'id': po.id,
      'codigo':po.codigo
    });
    this.showChildModal("Actualizar");
  }

/**
 * Muestra el modal para crear o actualizar segun corresponda.
 * @param tipo si es crear o actualizar
 */
  showChildModal(tipo:string): void {
    if(tipo === "Crear"){
      this.title = "Crear Especificación";
      this.isNew = true;
    } else if(tipo === "Actualizar"){
      this.title = "Actualizar Especificación";
      this.isNew = false;
    }
    this.lgModal.show();
  }

/**
 * Cierra el modal
 */
  hideChildModal(): void {
    this.lgModal.hide();
    this.cleanForm();
  }

/**
 * Cierra el mensaje de alerta.
 */
  onClosed(): void {
    this.isopen = false;
  }

/**
 * Muestra un error
 * @param  msg mensaje del error
 */
 showError(msg:string){
   if(msg == undefined){
     this.alert = 'No tiene permisos para realizar la acción.';
   }
   else{
     this.alert = msg;
   }
   this._loaddata.loadChange(100);
   this.isopen =true;
 }

/**
 * Limpia el formulario para volver a utilizarlo despues.
 */
  cleanForm():void{
    this.signupForm.reset();
    this.signupForm = new FormGroup({
      'id': new FormControl("-1",Validators.required),
      'codigo': new FormControl(null,Validators.required),
      'clientes':new FormArray([])
    });
  }

/**
 * Actualiza el listado por la paginacion
 * @param data nuevo listado o mensaje de error.
 */
  updateData(data:any):void{
    if(data === "Error al cargar listado."){
      this.showError(data);
    }
    else{
      this.data_list = data;
    }
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/especificacion/especificacion.component.ts